import { gql } from "@apollo/client";

import { GRAPHQL_METHODS } from "../../utils/constants";
import { networkGraphqlRequest } from "../../utils/networkUtils";

const UPDATE_STATUS = gql`
  mutation UpdateStatus($cmd: UpdateDemandStatusCmd!) {
    updateDemandStatus(cmd: $cmd)
  }
`;

function requestData(client, complaintId, status) {
  const params = {
    cmd: {
      caseNumber: complaintId,
      status: status,
    },
  };
  return networkGraphqlRequest(
    GRAPHQL_METHODS.MUTATION,
    client,
    UPDATE_STATUS,
    params
  );
}

export default requestData;
